// extracted by mini-css-extract-plugin
export default {"box":"addupdate_box__xiGsu"};